handleAuthSetData